module.exports = __webpack_public_path__ + "img/zoo.4e8eef9f.jpg";